import { Component, Output, EventEmitter } from "@angular/core";
import { NavigationHelper } from "../../services/navigation.helper"; // ajuste caminho se necessário
import { AuthService } from "../../auth.service";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.css"],
})
export class MenuComponent {
  @Output() itemSelected = new EventEmitter<any>();
  username: string = "";

  constructor(private navHelper: NavigationHelper, private auth: AuthService) {}

  ngOnInit() {
    this.username = this.auth.userdata?.username || "Usuário";
  }

  navigate(path: string, emitValue: string) {
    this.navHelper.router.navigate([path]).then(() => {
      this.itemSelected.emit(emitValue);
    });
  }

  goToSettings() {
    this.navigate("/instellingen", "instellingen");
  }

  goToBranche() {
    this.navigate("/branches", "branches");
  }

  goToDepartments() {
    this.navigate("/departments", "departments");
  }

  goToUsers() {
    this.navigate("/users", "users");
  }

  goToPriority() {
    this.navigate("/priority", "priority");
  }

  goToStatus() {
    this.navigate("/status", "status");
  }

  goToTicket() {
    this.navigate("/tickets", "tickets");
  }

  isActive(path: string): boolean {
    const url = this.navHelper.router.url;
    const p = path.startsWith('/') ? path : '/' + path;
    return url === p || url.startsWith(p + '/') || url.startsWith(p + '?');
  }
}
